import styled from 'styled-components';

export const Container = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.tertiary.main};
`;

export const Title = styled.div`
  display: block;
  padding: 16px 16px 0 16px;
  font-size: 16px;
  font-weight: bold;
`;

export const Count = styled.span`
  font-weight: normal;
`;

export const Toggle = styled.button`
  display: block;
  box-sizing: border-box;
  padding: 0 16px 16px 16px;
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-align: center;
  text-decoration: underline;
  color: ${({ theme }) => theme.primary.main};
`;
